import {withFormik} from 'formik';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import yup from 'yup';
import AdminFileDetails from '../details/form';
import {FILE_TYPE_PDF, FILE_TYPE_VIDEO} from '../../../common/types';
import {validationRegex as youtubeRegex} from '../../../../../util/youtube';

const schema = yup.object()
	.shape({
		name: yup.string().ensure()
			.max(50, 'The title must be less than 50 characters')
			.required('The title is required field'),
		description: yup.string().ensure()
			.max(200, 'The description must be less than 200 characters'),
		sortOrder: yup.string().ensure()
			.max(5, 'The sort order must be less than 5 characters')
			.matches(/^[0-9]+|^$$/, 'The sort order must be a number'),
		type: yup.string().ensure().required().default(FILE_TYPE_PDF),
		media: yup.string().ensure().when('type', (type, fieldSchema) => (
			type === FILE_TYPE_PDF ? fieldSchema.required('A file must be attached') : fieldSchema
		)),
		poster: yup.string().ensure()
			.matches(/^[^#]*$/, 'The thumbnail cannot contain \'#\' character'),
		streaming: yup.string().ensure().when('type', (type, fieldSchema) => (
			type !== FILE_TYPE_VIDEO ? fieldSchema :
				fieldSchema.required('The youtube link must be provided')
					.matches(youtubeRegex, 'Youtube URL should be like https://www.youtube.com/watch?v=videoid1234')
		))
	});

const enhance = compose(
	withFormik({
		mapPropsToValues(props) {
			return schema.cast(props.item || {});
		},
		handleSubmit(values, {props}) {
			props.doSubmit(values);
		},
		validationSchema: schema
	}),
	lifecycle({
		componentWillUnmount() {
			const {props: {values: {mediaTask, posterTask}}} = this;

			if (mediaTask && mediaTask.isPending) {
				mediaTask.cancel();
			}

			if (posterTask && posterTask.isPending) {
				posterTask.cancel();
			}
		}
	}),
	withHandlers({
		dropMediaValue: props => () => {
			const {setFieldValue} = props;

			setFieldValue('media', '');
			setFieldValue('mediaTask', undefined);
		}
	})
);

export default enhance(AdminFileDetails);



// WEBPACK FOOTER //
// ./src/client/components/admin/files/details/index.js